import { render, staticRenderFns } from "./EventFeedbackBlockAdmin.vue?vue&type=template&id=4f988db0&scoped=true"
import script from "./EventFeedbackBlockAdmin.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventFeedbackBlockAdmin.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EventFeedbackBlockAdmin.vue?vue&type=style&index=0&id=4f988db0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f988db0",
  null
  
)

export default component.exports